import { publicFallback } from "@app/.core/AppRoutes";
import {
  apiAuthSignin,
  apiAuthTwoFactorTurnOff,
  apiAuthTwoFactorTurnOn,
} from "@lib/api/auth";
import { setAuth } from "@lib/redux/slices/auth";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { AuthUser } from "@lib/types/Auth";
import { toast } from "react-toastify";

export const useAuthQueries = (props: UseQueriesProps) => {
  const { navigate, dispatch, id, messages } = props;
  const queryClient = useQueryClient();

  const signInMutation = useMutation<
    AxiosResponse<AuthUser>,
    AxiosError<any>,
    { username: string; password: string; twoFactorAuthenticationCode?: string }
  >({
    mutationFn: apiAuthSignin,
    onSuccess: ({ data }) => {
      dispatch(setAuth(data));
      toast.dismiss();
      navigate(publicFallback);
    },
  });

  // const twoFactorCreateQuery = useQuery({
  //   queryFn: apiAuthTwoFactorCreate,
  //   queryKey: ["qr-generate", id],
  //   enabled,
  // });

  const turnOnTwoFactorMutation = useMutation({
    mutationFn: apiAuthTwoFactorTurnOn,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["manager", id],
      });
    },
  });

  const turnOffTwoFactorMutation = useMutation({
    mutationFn: apiAuthTwoFactorTurnOff,
    onSuccess() {
      toast.success(
        (messages["common.removedMessage"] as string).replace(
          "{name}",
          messages["common.twoFactor"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: ["manager", id],
      });
    },
  });

  return {
    signInMutation,
    // twoFactorCreateQuery,
    turnOnTwoFactorMutation,
    turnOffTwoFactorMutation,
  };
};
